import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

export const Container = styled.div`
    padding: ${rem(16)} ${rem(8)};
    border-radius: ${rem(8)};
    display: flex;
    flex-direction: column;
    gap: ${rem(8)};

    & h2,
    h3 {
        margin-top: 0;
        color: ${({ theme }) => theme.colors.greyscale.gray50};
    }
`;

export const InformationWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${rem(24)};
    padding: 0px ${rem(8)};

    & div {
        flex: 1 1 calc(50% - 24px);
    }
`;

export const Title = styled.h2`
    margin: 0;
`;
